<template>
    <el-dialog :title="title" class="operate_contacts_dialog" :visible="visible" :before-close="handleClose" :close-on-click-modal="false">
        <el-form>
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系人姓名" prop="contactsName">
                            <el-input v-model="form.contactsName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号" prop="idCard">
                            <el-input :disabled="!!currentRow" v-model="form.idCard"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码" prop="contactsMobile">
                            <el-input v-model="form.contactsMobile"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import { checkExists, addContact, updateContact } from '../../../../../../api/register/cargoStationInfo.js';
import { identityVerify, phoneVerify } from '../../../../../../constant/formRegular.js';

const DEFAULT_FORM = {
    contactsName: '',
    idCard: '',
    contactsMobile: ''
};

export default {
    name: 'operateContactsDialog',
    props: {
        stationCode: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            loading: false,
            title: '',
            visible: false,
            rules: {
                contactsName: [{ required: true, message: '请输入联系人姓名', trigger: ['blur', 'change'] }],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: ['blur', 'change'] },
                    { pattern: identityVerify, message: '请输入正确格式的身份证', trigger: ['blur', 'change'] }
                ],
                contactsMobile: [
                    { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
                    { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] }
                ]
            },
            currentRow: null, // 编辑时当条数据
            version: null, // 编辑时所需传参
            form: JSON.parse(JSON.stringify(DEFAULT_FORM))
        };
    },
    computed: {
        ...mapState(['supplier']),
        supplierCode() {
            return this.supplier ? this.supplier.supplierCode : this.$route.query.supplierCode;
        },
        currentStationCode() {
            return this.currentRow ? this.currentRow.stationCode : this.stationCode;
        }
    },
    methods: {
        open(row) {
            this.visible = true;
            this.title = row ? '货站联系人修改' : '货站联系人新增';
            this.initForm(row);
        },
        initForm(row) {
            if (!row) {
                this.currentRow = null;
                this.version = null;
                return false;
            }
            this.currentRow = row;
            this.version = row.version;
            this.form.contactsName = row.contactsName;
            this.form.idCard = row.idCard;
            this.form.contactsMobile = row.contactsMobile;
        },
        handldCheckExist() {
            const params = {
                ...this.form,
                stationCode: this.currentStationCode,
                supplierCode: this.supplierCode
            };
            return checkExists(params);
        },
        handleConfirm() {
            this.$refs.ruleForm.validate().then(valid => {
                if (!valid) return false;
                let apiFunc = addContact;
                let successMsg = '新增货站联系人成功!';
                if (this.currentRow) {
                    apiFunc = updateContact;
                    successMsg = '修改货站联系人成功!';
                }
                this.loading = true;
                this.handldCheckExist().then(this.getParams).then(apiFunc).then(res => {
                    if (res && +res.code === 0) {
                        this.$emit('success', this.currentStationCode);
                        this.$message.success(successMsg);
                        this.handleClose();
                    }
                }).finally(() => { this.loading = false; });
            }).catch(e => {});
        },
        getParams(checkRes) {
            if (checkRes && +checkRes.code === 0) {
                const params = JSON.parse(JSON.stringify(this.form));
                if (this.currentRow) {
                    params.id = this.currentRow.id;
                    params.version = this.version;
                }
                params.stationCode = this.currentStationCode;
                params.supplierCode = this.supplierCode;
                // existsFlag 为 true时，将返回数据覆盖部分传参
                if (checkRes.data.existsFlag) {
                    params.contactsMobile = checkRes.data.contactsMobile;
                    params.contactsName = checkRes.data.contactsName;
                    params.idCard = checkRes.data.idCard;
                    params.mipAccount = checkRes.data.mipAccount;
                }
                return params;
            } else {
                throw new Error('检验供应商货站联系人报错!');
            }
        },
        handleClose() {
            this.clear();
            this.visible = false;
        },
        clear() {
            this.currentRow = null;
            this.version = null;
            this.form = JSON.parse(JSON.stringify(DEFAULT_FORM));
            this.$refs.ruleForm.clearValidate();
        }
    }
};
</script>
<style lang="less">
.operate_contacts_dialog {
    // .el-form-item {
    //     margin-bottom: 10px;
    // }
    // .address-form-item {
    //     display: flex;
    // }
    .el-form-item__error {
        padding-top: 0px;
    }
    .baidu_map_input {
        margin-top: 6px;
    }
}
</style>